import axios from 'axios'

import config from '../../config'
import applyCaseConvert from './apply-case-convert'
import getLocaleParam from './get-locale-param'

// creating the axios api instance for omnitech api
const client = applyCaseConvert(axios.create())

// construct api call url
function getUrl(endpoint) {
  const apiHost = config.get('api.host')
  return `${apiHost}/api/${endpoint}`
}

function setAuthorizationHeader({ authToken, deviceUdid }) {
  client.defaults.headers.common['X-AUTH-TOKEN'] = authToken
  client.defaults.headers.common['X-DEVICE-UDID'] = deviceUdid
}

// send request to api endpoint
function request(options) {
  const url = getUrl(options.endpoint)

  return client.request({
    url,
    ...options,
    params: {
      ..._.get(options, 'params', {}),
      locale: getLocaleParam()
    }
  })
}

export default {
  client,
  request,
  setAuthorizationHeader
}
